import React from "react";
import { Navigate, useParams } from "react-router-dom";

/**
 * /profile/:uid/:menuId/comandas/stock con la UI nueva: el stock ahora vive en Costos
 * (Insumos, filtrado a los controlados). Lo usan los favoritos viejos y quien tenía la
 * pestaña abierta.
 *
 * Se declara en App.js como ruta HERMANA de ComandasLayout, no como hija: una hija monta
 * ComandasProvider (suscripciones de mesas, órdenes, impresoras) sólo para redirigir.
 * `state.from` hace que la ← de Costos vuelva a Comandas.
 */
export default function ComandasStockRedirect() {
  const { uid, menuId } = useParams();
  return <Navigate to={`/profile/${uid}/${menuId}/costs/insumos?f=controlados`} replace state={{ from: "comandas" }} />;
}
